import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import LiveQuestionsTable from './LiveQuestionsTable';
const LiveQuestions = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Live Questions' parent='Live Questions'  />
      <Container fluid={true}>
        <Row>
          <LiveQuestionsTable  />
        </Row>
      </Container>
    </Fragment>
  );
};

export default LiveQuestions;
